import * as React from "react";
import Box from "@mui/joy/Box";


export default function RightSide() {
  return (
    <Box
      sx={(theme) => ({
        display: { xs: "none", md: "block" },
        flex: 1,
        height: "100vh",
        backgroundColor: "background.level1",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundImage:
          "url(https://cdn.iskconkanpur.org/static/images/IMG_1738.JPG)",
        [theme.getColorSchemeSelector("dark")]: {
          backgroundImage:
            "url(https://cdn.iskconkanpur.org/static/images/IMG_1738.JPG)",
        },
      })}
    />
  );
}
